<template>
    <div class="orderorder">
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-dropdown trigger="click" @command="handleCommand" style="margin-right: 10px">
                    <el-button type="primary" :disabled="isAdd || !isedit">
                        {{ $t('common.label') }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1" v-if="perData.allow_print == 1">格式1</el-dropdown-item>
                        <el-dropdown-item command="2" v-if="perData.allow_print == 1">格式2</el-dropdown-item>
                        <el-dropdown-item command="3">{{ $t('common.export') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button type="primary" size="mini" :disabled="isedit" @click="serial()">{{ $t('common.electronicScale') }}</el-button>

                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                    >{{ $t('common.add') }}</el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                    >{{ $t('common.edit') }}</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                    >{{ $t('common.delete') }}</el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                <el-button type="primary" size="mini" @click="exportFile" :disabled="!isedit">{{ $t('common.export') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                    form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                }}</el-button>
            </div>
        </div>

        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <el-select
                                    v-model="form.billtype_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    :disabled="isedit"
                                >
                                    <el-option
                                        v-for="(item, index) in allArr.billtype"
                                        :key="index"
                                        :label="item.billtype_no + ' - ' + item.billtype_name"
                                        :value="item.billtype_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-col>

                    <!-- <el-col :span="4">
                        <el-form-item label="柜台:" label-width="180">
                            <el-select
                                v-model="form.counter_no"
                                clearable
                                default-first-option
                                filterable
                                placeholder="请选择"
                                :disabled="isedit"
                            >
                                <el-option
                                    v-for="(item, index) in allArr.counter"
                                    :key="index"
                                    :label="item.kind_no + ' - ' + item.kind_name"
                                    :value="item.kind_no.toString()"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 4 : 8">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="table1" @mouseleave="dtlleave">
            <div class="title">
                <el-form style="width: 100%" :model="topLeftForm">
                    <el-row :gutter="20">
                        <el-col :span="4">
                            <el-form-item :label="$t('common.billNo') + '：'">
                                <span>{{ topLeftForm.in_no || '' }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5"
                            ><el-form-item label="供应商：">
                                <span>{{ topLeftForm.in_cust_name || '' }}</span>
                            </el-form-item></el-col
                        >
                        <el-col :span="4"
                            ><el-form-item label="金成色：">
                                <span>{{ topLeftForm.in_gold_name || '' }}</span>
                            </el-form-item></el-col
                        >
                        <el-col :span="4"
                            ><el-form-item :label="$t('common.totalQty') + '：'">
                                <span>{{ topLeftForm.in_qty || '' }}</span>
                            </el-form-item></el-col
                        >
                        <el-col :span="3"
                            ><el-form-item :label="$t('common.totalWeight') + '：'">
                                <span>{{ topLeftForm.in_wgt || '' }}</span>
                            </el-form-item></el-col
                        >
                        <el-col :span="4"
                            ><el-form-item label="入库金额：">
                                <span>{{ topLeftForm.in_amt || '' }}</span>
                            </el-form-item></el-col
                        >
                    </el-row>
                </el-form>
                <div style="display: flex; margin-bottom: 18px">
                    <el-input
                        placeholder="请输入入库单号"
                        v-model="topIptInsjOrder"
                        @keydown.native="iptKeydownEvent($event)"
                        clearable
                        :disabled="isedit"
                    >
                    </el-input>
                    <el-button type="primary" style="margin-left: 10px" @click="getDivideInfo('btn')" :disabled="isedit">分称</el-button>
                    <el-button type="" :disabled="isedit" @click="showImpotDialog = true">导入</el-button>
                </div>
            </div>
            <vxe-table
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                :height="maxHeight"
                show-overflow
                highlight-hover-row
                :loading="loading"
                show-footer-overflow
                :footer-method="footerMethod"
                show-footer
                :keyboard-config="{ isArrow: true, isDel: true, isEdit: true }"
                :row-class-name="rowChange"
                :data="form.dtl"
                :mouse-config="{ selected: true }"
                :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                @cell-mouseenter="dtlenter"
                :key="refushTable"
                :scroll-y="{ enabled: true, gt: 50 }"
            >
                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                <vxe-table-column type="seq" field="seq" width="70" title="序号">
                    <template slot="header">
                        <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                    </template>
                    <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                            <i class="el-icon-circle-plus-outline" @click="adddtl"></i>
                            <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                        </span>
                        <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                    </template>
                </vxe-table-column>

                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                        v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select' &&
                            item.field != 'saleamt' &&
                            item.field != 'inamt' &&
                            item.field != 'stone1_amt' &&
                            item.field != 'stone2_amt' &&
                            item.field != 'stone3_amt' &&
                            item.field != 'stone4_amt' &&
                            item.field != 'stone5_amt' &&
                            item.field != 'stone_amt' &&
                            item.field != 'mainstone_amt' &&
                            item.field != 'qty' &&
                            item.field != 'trans_wgt'
                        "
                    >
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                :type="item.column_type"
                                @keydown.native="jumptable($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column
                        v-if="item.column_status == 1 && item.column_type == 'select'"
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                $selectLable.selectLable(
                                    row[item.field],
                                    allArr[item.field.replace('_no', '')],
                                    item.field,
                                    item.field.replace('_no', '_name')
                                )
                            }}</span>
                        </template>
                        <template v-slot:edit="{ row }">
                            <el-select
                                size="mini"
                                v-model="row[item.field]"
                                ref="stylefocus"
                                filterable
                                default-first-option
                                placeholder="请选择"
                                @change="changeData(row, item.field.replace('_no', ''))"
                                @keydown.native="jumptable($event, row, item.field)"
                            >
                                <el-option
                                    v-for="option in allArr[item.field.replace('_no', '')] || []"
                                    :key="option[item.field.replace('_no', '') + '_no']"
                                    :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                    :value="option[item.field.replace('_no', '') + '_no']"
                                    :disabled="option.status == 0"
                                ></el-option>
                            </el-select>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="折足重"
                        field="trans_wgt"
                        :width="item.column_width"
                        :edit-render="{}"
                        class-name="jump"
                        v-if="item.field == 'trans_wgt' && item.column_status == 1"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ countTransWgt(row).toFixed(systemSet.wgt) }}</span>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column
                        field="qty"
                        title="数量"
                        v-if="item.field == 'qty' && item.column_status == 1"
                        :width="item.column_width"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ row.qty }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="主石金额"
                        :width="item.column_width"
                        field="mainstone_amt"
                        class-name="jump"
                        :edit-render="{}"
                        v-if="item.field == 'mainstone_amt' && item.column_status == 1"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('mainstone_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone1_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone1_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone1_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone2_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone2_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone2_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone3_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone3_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone3_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone4_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone4_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone4_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone5_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone5_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone5_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        field="stone_amt"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-if="item.field == 'stone_amt' && item.column_status == 1"
                        :key="item.field + index"
                        :edit-render="{}"
                        class-name="jump"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('stone_amt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column
                        title="入库金额"
                        :width="item.column_width"
                        v-if="item.field == 'inamt' && item.column_status == 1"
                        field="inamt"
                        class-name="jump"
                        :edit-render="{}"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('inamt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column
                        title="出库金额"
                        :width="item.column_width"
                        v-if="item.field == 'saleamt' && item.column_status == 1"
                        field="saleamt"
                        class-name="jump"
                        :edit-render="{}"
                        :key="item.field + index"
                    >
                        <template v-slot:edit="{ row }">
                            <span>{{ calculationInAndOut('saleamt', row).toFixed(systemSet.amt) }}</span>
                        </template>
                    </vxe-table-column>
                </template>

                <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                </template>
            </vxe-table>
        </div>
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item :label="$t('common.totalQty') + '：'">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.totalWeight') + '：'">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">{{ $t('common.cancel') }}</el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialog" width="45%" :before-close="handleClose">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'importdtl_sepwgt'"
                        multiple
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false" destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="dialogFormVisible" width="35%">
            <div class="printBox" id="prints" ref="prints">
                <div v-for="(item, index) in LabelList" :key="index" style="page-break-after: always">
                    <div style="display: flex; align-items: center; justify-content: center">
                        <div style="display: flex; flex-direction: column; transform: rotate(270deg)">
                            <div style="margin-bottom: 15px; line-height: 1">
                                <div style="font-size: 16px; text-align: center">{{ systemSet.company }}</div>
                                <div style="font-size: 16px">{{ item.barcode_name }}</div>
                                <div style="display: flex; font-size: 14px">
                                    <div>总重:{{ item.wgt }}g</div>
                                    <div style="margin-left: 10px">{{ item.specs }}</div>
                                </div>
                                <div style="display: flex; font-size: 14px">
                                    <div>金重:{{ item.gold_wgt }}g</div>
                                    <div style="margin-left: 10px">银重:{{ item.silver_wgt }}g</div>
                                </div>
                                <div style="display: flex; font-size: 14px">
                                    <div>工费:{{ item.salewgt_prc }}/克</div>
                                    <div style="margin-left: 10px">件工费:{{ item.saleqty_prc }}</div>
                                </div>
                                <div style="font-size: 12px">合格证:QB/T1131-20</div>
                                <div style="font-size: 12px">执行标准:GB11887-20</div>
                            </div>
                            <div style="line-height: 1">
                                <div style="font-size: 16px">标签撕毁&emsp;不退不换</div>
                                <div style="font-size: 14px">款&nbsp;号：{{ item.style_no }}</div>
                                <div style="font-size: 14px">证&nbsp;书：{{ item.certificateno }}</div>
                                <div style="text-align: center">
                                    <img
                                        :id="'barcode' + index"
                                        style="
                                            height: 50px;
                                            width: 120px;
                                            margin: 0px;
                                            padding: 0px;
                                            shape-rendering: crispedges;
                                            image-rendering: optimizeQuality; /*改善下载后不会产生锯齿*/
                                            vector-effect: non-scaling-stroke;
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisibleModify()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { multiplication, multiplication2, getExportExcel } from '@/utils/multAdexportExcel.js';
import {
    apiGetDividedData,
    apiGetDividedPull,
    apiModifyDividedData,
    apiAddDividedData,
    apiDelDividedData,
    apiCurrentPermisson,
    apiCheckDivided,
    apiSystem,
    apiCanModifyDividedData,
    apiGetDividedBtnInfo,
    apiIsOrderQuote,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiGetSepwgtPrintLink,
    apiGetSepwgtPrintLinkExport
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
export default {
    name: 'separateweight',
    data() {
        return {
            query: {},
            LabelList: {},
            dialogFormVisible: false,
            allArr: '',
            form: { remark: '' },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            dialogImageUrl: '',
            dialogVisible: false,
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', //列表当前位置,
            isSave: true,
            type: '4',
            maxHeight: 480,
            showImpotDialog: false,
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '22',
            perData: {}, //权限
            rowSeq: 0,
            wgtValue: 0,
            reader: null, // 声明为组件属性
            port: null, // 声明为组件属性
            shouldStopReading: false
        };
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getStoneData();
        this.getTable();
        this.getPermission();
        document.addEventListener('keydown', (event) => {
            if (event.key === 'F9') {
                this.getValue();
            } else {
                this.mykeyup(event);
            }
        });
        // this.geData();
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    beforeRouteLeave(to, from, next) {
        // 返回一个 Promise，包含关闭串口的异步操作
        const closePromise = this.closeSerial();

        // 等待所有异步操作完成后再销毁组件
        Promise.all([closePromise])
            .then(() => {
                console.log('Serial port closed successfully.');
            })
            .catch((error) => {
                console.error('Error closing serial port:', error);
            });
        next();
    },
    beforeDestroy() {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'F9') {
            }
        });
    },
    activated() {
        // if (this.$route.query.isadd == 0) {
        //     this.add();
        // } else {
        //     this.geData();
        // }
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        handleCommand(command) {
            if (command == 1) {
                this.labelClick();
            } else if (command == 2) {
                this.labelClick2();
            } else if (command == 3) {
                this.labelClick3();
            }
        },
        labelClick3() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                id: this.form.id,
                dtlid: strId.join(','),
                is_exports: 1
            };
            apiGetSepwgtPrintLinkExport(params)
                .then((res) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([res.data], { type: 'application/x-xls' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = this.$t('common.label') + '.xlsx'
                    link.click();
                    this.form.is_exports = 0;
                })
                .catch((error) => {
                    console.error('API Request Failed:', error); // 错误处理
                });
        },
        dialogVisibleModify() {
            this.dialogFormVisible = false;
            this.$print(this.$refs.prints);
        },
        labelClick2() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                id: this.form.id,
                dtlid: strId.join(',')
            };
            this.dialogFormVisible = true;
            apiGetSepwgtPrintLink(params).then((res) => {
                if (res.code == 2000) {
                    this.LabelList = res.data.data;
                    for (let index = 0; index < this.LabelList.length; index++) {
                        if (this.LabelList[index].barcode) {
                            this.$nextTick(() => {
                                // 待生成条码的内容
                                // this.LabelList[index].barcode
                                JsBarcode('#barcode' + index, this.LabelList[index].barcode, {
                                    // format: 'EAN13', //选择要使用的条形码类型
                                    width: 5, //设置条之间的宽度
                                    height: 280, //高度
                                    displayValue: true, //是否在条形码下方显示文字
                                    // text: '456', //覆盖显示的文本
                                    // fontOptions: 'bold italic', //使文字加粗体或变斜体
                                    font: '楷体', //设置文本的字体
                                    // textAlign: 'left', //设置文本的水平对齐方式
                                    // textPosition: 'top', //设置文本的垂直位置
                                    textMargin: 20, //设置条形码和文本之间的间距
                                    fontSize: 80 //设置文本的大小
                                    // background: '#eee', //设置条形码的背景
                                    // lineColor: '#2196f3' //设置条和文本的颜色。
                                    // margin: 10 //设置条形码周围的空白边距
                                });
                            });
                        }
                    }
                    // console.log(res.data);
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 标签打印
        labelClick() {
            let data = this.$refs.xTable1.getCheckboxRecords();
            let strId = [];
            if (data.length !== 0) {
                for (let i = 0; i < data.length; i++) {
                    strId.push(data[i].id);
                }
            }
            let params = {
                id: this.form.id,
                dtlid: strId.join(',')
            };
            apiGetSepwgtPrintLink(params).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        stopReading() {
            // 设置一个标志来指示循环是否应该停止
            this.shouldStopReading = true;
        },
        async serial() {
            if ('serial' in navigator) {
                // 重置停止读取的标志
                this.shouldStopReading = false;

                this.port = await navigator.serial.requestPort();
                await this.port.open({ baudRate: 9600 });

                const decoder = new TextDecoderStream();
                this.port.readable.pipeTo(decoder.writable);
                const inputStream = decoder.readable.pipeThrough(new TransformStream(new LineBreakTransformer()));
                this.reader = inputStream.getReader();

                try {
                    while (true) {
                        const { value, done } = await this.reader.read();
                        if (done || this.shouldStopReading) {
                            // 检查停止读取的标志
                            break;
                        }
                        var wgt = value;
                        var numberStr = wgt.replace(/[^0-9.]/g, '');
                        this.wgtValue = parseFloat(numberStr);

                        console.log('this.wgtValue:', this.wgtValue);
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    this.reader.releaseLock();
                    await this.port.close();
                }
            }
        },
        async closeSerial() {
            try {
                // 停止数据读取循环
                this.stopReading();
                if (this.reader) {
                    await this.reader.cancel(); // 取消读取器
                    this.reader.releaseLock(); // 释放读取器锁定
                    this.reader = null; // 清空读取器
                }
                if (this.port) {
                    const writer = this.port.writable.getWriter();
                    await writer.close(); // 关闭写入器
                    this.port.close(); // 关闭串口
                    this.port = null; // 清空串口
                }
            } catch (error) {
                console.error('Error closing serial port:', error);
            }
        },
        getValue() {
            // console.log(this.wgtValue, '?');
            if ((this.isAdd && this.rowSeq != 0 && this.reader != null) || (!this.isEdit && this.rowSeq != 0 && this.reader != null)) {
                var table1 = this.$refs.xTable1.getTableData().fullData;
                // console.log(table1, this.rowSeq, 'ddd!');
                table1[--this.rowSeq].wgt = this.wgtValue;
                if (this.rowSeq >= table1.length) {
                } else {
                    this.$refs.xTable1.setActiveCell(this.$refs.xTable1.getTableData().fullData[++this.rowSeq], 'wgt');
                }
                // document.getElementById('bInput').value = this.wgtValue;
            }
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/separateweight') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        // 拖拽成功的钩子
        uploadSuccess(res) {
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.form.dtl = res.data;
                this.showImpotDialog = false;
            } else {
                this.$message.error(res.data.info[0]);
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_sepwgt`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        // 获取页面信息-----------------------------------------
        geData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiGetDividedData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    this.maxHeight = 480;
                    if (res.data.data.dtl.length > 4) {
                        let length = res.data.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            this.$load.close();
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiGetDividedPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        async getDivideInfo(t) {
            if (this.topIptInsjOrder.trim() == '') {
                this.$message.info('请输入入库单号后进行查询');
                return;
            }
            let isuse = await apiIsOrderQuote({ insj_no: this.topIptInsjOrder });
            if (isuse.data.isUse == 0) {
                this.getPassTestData(t);
            } else {
                this.$confirm('此入库单号已被引用，是否继续？', '提示', {
                    confirmButtonText: this.$t('common.confirm') ,
                    cancelButtonText: this.$t('common.cancel') ,
                    type: 'warning'
                })
                    .then(() => {
                        this.getPassTestData(t);
                    })
                    .catch(() => {
                        this.topIptInsjOrder = '';
                    });
            }
            return;
        },
        getPassTestData(t) {
            apiGetDividedBtnInfo({ insj_no: this.topIptInsjOrder }).then((res) => {
                if (res.code === 2000) {
                    this.topLeftForm = res.data.inmain;
                    if (t == 'btn') {
                        this.form.dtl = res.data.indtl;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.topIptInsjOrder = '';
            });
        },
        iptKeydownEvent(e) {
            if (e.keyCode === 13) {
                this.getDivideInfo('ipt');
            }
        },
        // changeData(row) {
        //     let style_no = row.style_no;
        //     let idx = this.allArr.style.findIndex((item) => {
        //         return item.style_no === style_no;
        //     });
        //     let info = this.allArr.style[idx];
        //     for (let key in info) {
        //         if (!info[key]) {
        //             info[key] = 0;
        //         }
        //     }
        //     Object.assign(row, info);
        // },
        changeData(row, type) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },

        // 折足重
        countTransWgt(row) {
            var a = Number(row.wgt || 0) * Number(row.alloy || 1);
            row.trans_wgt = a.toFixed(this.systemSet.wgt);
            return a ? a : 0;
        },
        calculationInAndOut(type, row) {
            if (type === 'mainstone_amt') {
                let a = multiplication2(row.mainstone_qty, row.mainstone_qty_prc, row.mainstone_wgt, row.mainstone_wgt_prc);
                row.mainstone_amt = a || 0;
                return row.mainstone_amt || 0;
            } else if (type === 'stone1_amt') {
                let a = multiplication2(row.stone1_qty, row.stone1_qty_prc, row.stone1_wgt, row.stone1_wgt_prc);
                row.stone1_amt = a || 0;
                return row.stone1_amt || 0;
            } else if (type === 'stone2_amt') {
                let a = multiplication2(row.stone2_qty, row.stone2_qty_prc, row.stone2_wgt, row.stone2_wgt_prc);
                row.stone2_amt = a || 0;
                return row.stone2_amt || 0;
            } else if (type === 'stone3_amt') {
                let a = multiplication2(row.stone3_qty, row.stone3_qty_prc, row.stone3_wgt, row.stone3_wgt_prc);
                row.stone3_amt = a || 0;
                return row.stone3_amt || 0;
            } else if (type === 'stone4_amt') {
                let a = multiplication2(row.stone4_qty, row.stone4_qty_prc, row.stone4_wgt, row.stone4_wgt_prc);
                row.stone4_amt = a || 0;
                return row.stone4_amt || 0;
            } else if (type === 'stone5_amt') {
                let a = multiplication2(row.stone5_qty, row.stone5_qty_prc, row.stone5_wgt, row.stone5_wgt_prc);
                row.stone5_amt = a || 0;
                return row.stone5_amt || 0;
            } else if (type === 'stone_amt') {
                let a =
                    Number(row.mainstone_amt || 0) +
                    Number(row.stone1_amt || 0) +
                    Number(row.stone2_amt || 0) +
                    Number(row.stone3_amt || 0) +
                    Number(row.stone4_amt || 0) +
                    Number(row.stone5_amt || 0);
                row.stone_amt = a || 0;
                return row.stone_amt || 0;
            } else if (type === 'inamt') {
                let a =
                    multiplication(row.qty, row.inqty_prc) +
                    (Number(row.inadd_qtywage) || 0) +
                    (multiplication(row.wgt, row.inwgt_prc) + (Number(row.inadd_wgtwage) || 0)) +
                    (Number(row.inadd_wage) || 0) +
                    (Number(row.certificate_amt) || 0) +
                    (Number(row.stone_amt) || 0);
                row.inamt = a || 0;
                return a || 0;
            } else {
                let a =
                    multiplication(row.qty, row.saleqty_prc) +
                    (Number(row.saleadd_qtywage) || 0) +
                    (multiplication(row.wgt, row.salewgt_prc) + (Number(row.saleadd_wgtwage) || 0)) +
                    (Number(row.saleadd_wage) || 0) +
                    (Number(row.certificate_amt) || 0) +
                    (Number(row.stone_amt) || 0);
                row.saleamt = a || 0;
                return a || 0;
            }
        },
        exportFile() {
            getExportExcel('billexport_sepwgt', { id: this.form.id }, '分称单据');
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.form = { dtl: [] };
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/separateweight');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            apiCanModifyDividedData({ id: this.form.id }).then((res) => {
                if (res.code === 2000) {
                    this.isSave = true;
                    if (this.isedit == true) {
                        if (this.form.check == 0) {
                            this.isedit = false;
                            if (this.form.dtl.length == 0) {
                                this.insertEvent(-1);
                            }
                        } else if (this.form.check == 1) {
                            this.isCheck = true;
                        }
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 保存修改------------------------------------------
        saveItSub() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                data['dtl'] = table1;
                data['inmain'] = this.topLeftForm;
                data['check'] = this.form.check == true ? '1' : '0';
                this.$load.show();
                if (this.isAdd == true) {
                    apiAddDividedData(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/separateweight');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyDividedData(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '' };
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 480;

                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 3; i++) {
                        this.insertEvent(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除产品-----------------------------------------
        delOrder() {
            apiCanModifyDividedData({ id: this.form.id }).then((res) => {
                if (res.code === 2000) {
                    this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        apiDelDividedData({
                            id: this.form.id
                        }).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '删除成功', type: 'success' });
                                if (res.data.data == null) {
                                    this.form = {};
                                    this.nullBtn = true;
                                } else {
                                    this.form = res.data.data;
                                    if (this.form.check == 1) {
                                        this.isCheck = true;
                                    } else {
                                        this.isCheck = false;
                                    }
                                }
                                this.last = res.data.last;
                                this.first = res.data.first;
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiCheckDivided({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/separateweight' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },
        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: '',
                alloy: 1,
                qty: 1,
                counter_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'seq');
            // this.$refs.stylefocus.focus();
        },
        // 不可编辑-------------------------------------
        activeRowMethod(row) {
            if (row.seq) {
                this.rowSeq = row.seq;
                //console.log(this.rowSeq, 'this.rowSeq');
            } else {
                ++this.rowSeq;
            }
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        // //计算入库金额
        // countAmountIn(row) {
        //     let b =
        //         Number(row.qty) * Number(row.inqty_prc) +
        //         Number(row.qty) * Number(row.inadd_qtywage) +
        //         Number(row.wgt) * Number(row.inwgt_prc) +
        //         Number(row.wgt) * Number(row.inadd_wgtwage) +
        //         Number(row.inadd_wage);
        //     row.inamt = b ? b : 0;
        //     return b ? b : 0;
        // },
        // //计算出库金额
        // countAmountOut(row) {
        //     let b =
        //         Number(row.qty) * Number(row.saleqty_prc) +
        //         Number(row.qty) * Number(row.saleadd_qtywage) +
        //         Number(row.wgt) * Number(row.salewgt_prc) +
        //         Number(row.wgt) * Number(row.saleadd_wgtwage) +
        //         Number(row.saleadd_wage);
        //     row.saleamt = b ? b : 0;
        //     return b ? b : 0;
        // },
        // countAllAmount(data) {
        //     return this.$utils.sum(data.map((row) => this.countAmount(row)));
        // },
        // 表尾合计---------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        let totalWgt = this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt);
                        // this.form.sumwgt = `${totalWgt ? totalWgt : 0} `;
                        this.$set(this.form, 'sumwgt', totalWgt);
                        return `${totalWgt} `;
                    } else if (column.property == 'trans_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'inamt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)} `;
                    } else if (column.property == 'qty') {
                        let totalQty = this.$utils.sum(data, column.property).toFixed(this.systemSet.qty);
                        // this.form.sumqty = `${totalQty ? totalQty : 0} `;
                        this.$set(this.form, 'sumqty', totalQty);
                        return `${totalQty} `;
                    } else if (column.property == 'saleamt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'mainstone_amt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'mainstone_qty') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else if (column.property == 'mainstone_wgt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)} `;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        //列配置相关接口

        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '22';
            }
            this.drawers = true;
        },

        checkMove() {},

        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        getTable() {
            apiGetListCorrespondingData({
                id: '22'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '147'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // refreshs() {
        //     this.$forceUpdate();
        // },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增分称管理
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length > 4 && length < 11) {
                this.maxHeight += 48;
            }
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.xTable1.remove(scoped.row);
        },
        goHistory() {
            this.$router.push({ path: '/separateHistory', query: { page: 'separateweight' } });
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            //问题1：回车键最后一条不需要输入的列处理
            //问题2：无法确定一个有几个需要跳过的列
            var addnum = 1; //跳过列的基本参数，每一个需要跳过的加1
            var addnumleft = 1;
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {}
                }
            }
            // 右移;
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }
            // 左移
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().fullData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    let allowBreak = true;
                    rows.forEach((item, index) => {
                        if (index === rowIndex) {
                            return;
                        }
                        if (item.barcode && item.barcode === row.barcode) {
                            this.$message.error('条码号不能重复');
                            row.barcode = '';
                            allowBreak = false;
                        }
                    });
                    if (allowBreak) {
                        // 跳转到下一列
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }
        }
    }
};
// 添加一个 LineBreakTransformer 类
class LineBreakTransformer {
    constructor() {
        this.chunks = '';
    }

    transform(chunk, controller) {
        this.chunks += chunk;
        const lines = this.chunks.split('\r\n');
        this.chunks = lines.pop();
        lines.forEach((line) => controller.enqueue(line));
    }

    flush(controller) {
        controller.enqueue(this.chunks);
    }
}
</script>

<style scoped>
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
</style>
<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}
.vxe-table thead {
    background-color: #ecf5ff;
}
.vxe-table {
    background: #fff;
}
.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}
.box1 .el-select {
    width: 20%;
}
.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}
.el-select {
    width: 100%;
}
.list-item1:hover {
    background-color: #f5f7fa;
}
.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}
.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}
.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;
        p {
            width: 150px;
        }
        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    .centerItem {
        width: 48%;
        text-align: center;
        /deep/ .el-upload--text {
            width: 100%;
        }
        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }
    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;
        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}
</style>
